import { render } from "./UnsnoozeNotificationRadio.vue?vue&type=template&id=63768e14"
import script from "./UnsnoozeNotificationRadio.vue?vue&type=script&lang=js"
export * from "./UnsnoozeNotificationRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__